module.exports = "/static/fonts/OpenSans-ExtraBoldItalic.eot";